import { useQuery } from '@tanstack/react-query';

import { Service } from '@/infra/services/bera';
import { BeraSummaryResult } from '@/types/Bera';

export interface GetSummaryResultParams {
	id: string;
	organization_id: string;
	company_id: string;
}

export type GetSummaryResultResponse = BeraSummaryResult;

export function useGetBeraSummaryResult(params: GetSummaryResultParams) {
	const enabled = !!params.organization_id && !!params.company_id && !!params.id;
	const results = useQuery(
		['bera_job_results', [params.organization_id, params.company_id, params.id]],
		() => Service.getSummaryResult(params),
		{
			enabled,
			retry: 0
		}
	);
	return {
		...results,
		data: results.data ?? ({} as GetSummaryResultResponse)
	};
}
